import { jsxs as h, jsx as i } from "react/jsx-runtime";
import { QUERIES as y } from "@fcamna/shared-component-foundations";
import { c as u } from "./index-65016bfa.mjs";
import e, { css as r } from "styled-components";
import "react";
import { u as $ } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { ModalWindow as b, ModalHeader as f, ModalBody as H } from "./modalWindow.js";
import "./_commonjsHelpers-92157f1b.mjs";
import "react-dom";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./useClient-0bbce34e.mjs";
import "./Aria-f5e019e2.mjs";
import "./closeButton.js";
import "./iconButton.js";
import "./button.js";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "./icon.js";
import "@fcamna/shared-icons";
import "./disclosure.js";
import "./focusTrap.js";
import "./hTag-27bb1617.mjs";
import "./index-5d51183d.mjs";
import "./tslib.es6-59e1c9d8.mjs";
const d = "82px", V = "536px", g = e(b)`
  &.ModalVideo {
    ${({
  theme: {
    components: {
      modalVideo: { ModalWindow: o }
    }
  }
}) => r(o)};

    @media ${y.mobile} {
      min-height: ${({ $mobileMargin: o }) => `calc(100% - ${o} - ${o})`};
    }
  }
`, N = e.div`
  ${({
  theme: {
    components: {
      modalVideo: { Container: o }
    }
  }
}) => r(o)};
`, x = e(f)`
  &.ModalVideo__header {
    ${({
  theme: {
    components: {
      modalVideo: { ModalHeader: o }
    }
  }
}) => r(o)};
  }
`, B = e(H)`
  &.ModalVideo__body {
    ${({
  theme: {
    components: {
      modalVideo: { ModalBody: o }
    }
  }
}) => r(o)};
  }
`;
function m({
  isOpen: o,
  handleCloseModal: a,
  children: p,
  mobileMargin: l = d,
  accessibilityOptions: n = {},
  idProps: s,
  className: c,
  modalVideoAccessibilityOptions: t = {
    modalAccessibilityOptions: n
  },
  ...M
}) {
  const _ = $({ label: "Modal Video" });
  return /* @__PURE__ */ h(
    g,
    {
      variant: "large",
      isOpen: o,
      onClose: a,
      bgOverlayColor: "rgba(0, 20, 46, 0.8)",
      $mobileMargin: l,
      className: u(["ModalVideo", c]),
      ...M,
      ...t == null ? void 0 : t.modalAccessibilityOptions,
      ..._,
      children: [
        /* @__PURE__ */ i(
          x,
          {
            idProps: s,
            onClose: a,
            className: "ModalVideo__header",
            accessibilityOptions: t.modalHeaderAccessibilityOptions
          }
        ),
        /* @__PURE__ */ i(B, { className: "ModalVideo__body", children: p })
      ]
    }
  );
}
m.Container = N;
m.mobileMargin = d;
m.tabletAndUpHeight = V;
export {
  m as ModalVideo
};
